// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const octillery: PokeData = {
  "id": 224,
  "name": "octillery",
  "height": 9,
  "weight": 285,
  "base_experience": 168,
  "types": [
    PokeType.WATER
  ],
  "api_moves": [
    "wrap",
    "water-gun",
    "hydro-pump",
    "ice-beam",
    "psybeam",
    "bubble-beam",
    "aurora-beam",
    "hyper-beam",
    "focus-energy",
    "constrict",
    "bubble",
    "octazooka",
    "lock-on",
    "helping-hand",
    "signal-beam",
    "bullet-seed",
    "rock-blast",
    "water-pulse",
    "wring-out",
    "gunk-shot",
    "charge-beam",
    "soak",
    "acid-spray"
  ],
  "moves": [
    "hydro-pump",
    "bubble-beam",
    "bubble",
    "bullet-seed",
    "rock-blast",
    "aqua-cutter",
    "rain-dance",
    "aqua-tail",
    "whirlpool",
    "water-spout",
    "life-dew",
    "liquidation",
    "brine"
  ],
  "evolution_chain": {
    "id": 114,
    "item": null,
    "species": [
      {
        "name": "remoraid",
        "order": 255,
        "types": [
          PokeType.WATER
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "octillery",
        "order": 256,
        "types": [
          PokeType.WATER
        ],
        "evolves_from_species_id": 223,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 25,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 133,
    "speed": 80,
    "ability_power": 187
  },
  "stat_changes": [],
  "catch_rate": 75,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
